// extracted by mini-css-extract-plugin
module.exports = {"voterRules":"index_voterRules__iWcWv","viewNum":"index_viewNum__hwq4z","voteWrapper":"index_voteWrapper__9uIaj"};